// eslint-disable-next-line import/prefer-default-export
export const IDENTIFICATOR_LIST = '/:clientToken/identificators';
